import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=3460b2f4&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=3460b2f4&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460b2f4",
  null
  
)

export default component.exports